package com.sweetlime.dungeonamigo.presentation.ui.components

import androidx.compose.foundation.border
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.sweetlime.dungeonamigo.presentation.ui.theme.BrandColors

@Composable
fun EmptyStateView(
    illustration: @Composable () -> Unit,
    headline: String,
    subtext: String,
    ctaText: String? = null,
    onCtaClick: (() -> Unit)? = null,
    modifier: Modifier = Modifier,
) {
    Column(
        modifier = modifier,
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(12.dp),
    ) {
        Box(modifier = Modifier.height(160.dp), contentAlignment = Alignment.Center) {
            illustration()
        }

        Text(
            text = headline,
            color = BrandColors.TextPrimary,
            fontSize = 20.sp,
            fontWeight = FontWeight.Bold,
            textAlign = TextAlign.Center,
        )

        Text(
            text = subtext,
            color = BrandColors.TextSecondary,
            fontSize = 14.sp,
            textAlign = TextAlign.Center,
            maxLines = 2,
            modifier = Modifier.padding(horizontal = 16.dp),
        )

        if (ctaText != null && onCtaClick != null) {
            OutlinedButton(
                onClick = onCtaClick,
                border = androidx.compose.foundation.BorderStroke(1.dp, BrandColors.Ember),
                colors = ButtonDefaults.outlinedButtonColors(contentColor = BrandColors.Ember),
                shape = RoundedCornerShape(10.dp),
            ) {
                Text(ctaText, fontSize = 14.sp, fontWeight = FontWeight.SemiBold)
            }
        }
    }
}
